import { LANGUAGE_KEYS } from 'config/languageKeys';

import { AuthData, AuthError } from './reducer.types';

const {
    LOGIN: {
        SCREEN_LOGIN_ALERT_GENERIC,
        SCREEN_PASSWORDFIELD_USERNAMEFIELD_INCORRECT,
        SCREEN__LOGIN_ALERT_ACCOUNT_CANCELED,
        SCREEN__LOGIN_ALERT_ACCOUNT_DEVICE_LIMIT,
        SCREEN__LOGIN_ALERT_ACCOUNT_SUSPENDED,
        SCREEN__LOGIN_ALERT_DEVICE_DELETED,
        SCREEN__LOGIN_ALERT_DEVICE_DISABLED,
        SCREEN__LOGIN_ALERT_DIFFERENT_ACCOUNT,
    },
} = LANGUAGE_KEYS;

export const NO_AUTH_DATA_ERROR = 'No auth data. User is not authenticated.';

export const INTERNAL_ERROR_CODE = {
    ACCOUNT_CANCELED: 20001,
    ACCOUNT_SUSPENDED: 20002,
    DEVICE_DELETED: 20003,
    DEVICE_DISABLED: 20004,
    DEVICE_ID_USED_FOR_ANOTHER_ACCOUNT: 20006,
    DEVICE_LIMIT_REACHED: 20007,
};

export const MY_LIST_NAME = 'MyList';
export const FAVORITE_LIST_NAME = 'FavoriteList';

export const detailsForError = (error: any): AuthError => {
    if (error.response?.status === 401) {
        return {
            message: SCREEN_PASSWORDFIELD_USERNAMEFIELD_INCORRECT,
            permanent: false,
            code: `${error.response.status}`,
        };
    }

    if (error.response?.status === 403) {
        switch (error.response?.data?.code) {
            case INTERNAL_ERROR_CODE.ACCOUNT_CANCELED:
                return {
                    message: SCREEN__LOGIN_ALERT_ACCOUNT_CANCELED,
                    permanent: true,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.ACCOUNT_CANCELED}`,
                };

            case INTERNAL_ERROR_CODE.ACCOUNT_SUSPENDED:
                return {
                    message: SCREEN__LOGIN_ALERT_ACCOUNT_SUSPENDED,
                    permanent: true,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.ACCOUNT_SUSPENDED}`,
                };

            case INTERNAL_ERROR_CODE.DEVICE_DELETED:
                return {
                    message: SCREEN__LOGIN_ALERT_DEVICE_DELETED,
                    permanent: true,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.DEVICE_DELETED}`,
                };

            case INTERNAL_ERROR_CODE.DEVICE_DISABLED:
                return {
                    message: SCREEN__LOGIN_ALERT_DEVICE_DISABLED,
                    permanent: true,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.DEVICE_DISABLED}`,
                };

            case INTERNAL_ERROR_CODE.DEVICE_ID_USED_FOR_ANOTHER_ACCOUNT:
                return {
                    message: SCREEN__LOGIN_ALERT_DIFFERENT_ACCOUNT,
                    permanent: false,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.DEVICE_ID_USED_FOR_ANOTHER_ACCOUNT}`,
                };

            case INTERNAL_ERROR_CODE.DEVICE_LIMIT_REACHED:
                return {
                    message: SCREEN__LOGIN_ALERT_ACCOUNT_DEVICE_LIMIT,
                    permanent: false,
                    code: `${error.response.status}/${INTERNAL_ERROR_CODE.DEVICE_LIMIT_REACHED}`,
                };

            default:
                break;
        }
    }

    return {
        message: SCREEN_LOGIN_ALERT_GENERIC,
        permanent: false,
        status: error.response?.status,
    };
};

export const appendCreationTimeToTokenData = (
    tokenData: AuthData,
    creationTime: number = Date.now(),
): AuthData => {
    return { ...tokenData, creation_time: creationTime };
};

export function isVoluntarySuspension(error: any) {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    return status === 403 && code === INTERNAL_ERROR_CODE.ACCOUNT_SUSPENDED;
}

export function isDeviceDeleted(error: any) {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    return status === 403 && code === INTERNAL_ERROR_CODE.DEVICE_DELETED;
}
